import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../utils/config";
import Usuario from "../../../models/Usuario";
import account_icon from "../../../assets/icons/account.svg";
import edit_icon from "../../../assets/icons/edit.svg";
import DeleteDialog from "../DeleteDialog";
import Loading from "../Loading";
import AlterarEmailModal from "../../modules/Configuracoes/AlterarEmailModal";
import AlterarContatoModal from "../../modules/Configuracoes/AlterarContatoModal";
import AlterarEstadoModal from "../../modules/Configuracoes/AlterarEstadoModal";
import AlterarCidadeModal from "../../modules/Configuracoes/AlterarCidadeModal";
import AlterarNomeModal from "../../modules/Configuracoes/AlterarNomeModal";
import AlterarSenhaModal from "../../modules/Configuracoes/AlterarSenhaModal";
import ConfirmarDeletarModal from "../../modules/Configuracoes/ConfirmarDeletarModal";
import ControllerConfiguracoes from "../../modules/Configuracoes/Home/controller";
import { Caixa, Acoes, RaizModais } from "./styled";

// Dados da conta (e-mail, telefone, estado, cidade, nome, senha). Antes ficavam em
// Configuracoes; sao dados do PERFIL da pessoa, entao moram no Perfil.
function ContaCardBase({ usuario }) {
  const [aberto, setAberto] = useState(null);
  const fechar = () => setAberto(null);
  const campos = [
    { id: "email", rotulo: "E-mail", valor: usuario.email },
    { id: "contato", rotulo: "Número de telefone", valor: usuario.celular },
    { id: "estado", rotulo: "Estado", valor: usuario.estado },
    { id: "cidade", rotulo: "Cidade", valor: usuario.cidade },
    { id: "nome", rotulo: "Nome e sobrenome", valor: usuario.nome },
    { id: "senha", rotulo: "Senha", valor: "••••••" },
  ];
  return (
    <>
      <RaizModais>
      {aberto === "email" && <AlterarEmailModal onClose={fechar} />}
      {aberto === "contato" && <AlterarContatoModal onClose={fechar} />}
      {aberto === "estado" && <AlterarEstadoModal onClose={fechar} />}
      {aberto === "cidade" && <AlterarCidadeModal onClose={fechar} />}
      {aberto === "nome" && <AlterarNomeModal onClose={fechar} />}
      {aberto === "senha" && <AlterarSenhaModal onClose={fechar} />}
      </RaizModais>
      <Caixa aria-labelledby="conta-titulo">
        <div className="top"><img src={account_icon} alt="" /><h3 id="conta-titulo">Dados da conta</h3></div>
        {campos.map((c) => (
          <div className="item" key={c.id}>
            <label>{c.rotulo}</label>
            <div className="linha">
              <span className="valor">{c.valor}</span>
              <button type="button" className="editar" aria-label={`Alterar ${c.rotulo.toLowerCase()}`} onClick={() => setAberto(c.id)}>
                <img src={edit_icon} alt="" />
              </button>
            </div>
          </div>
        ))}
      </Caixa>
    </>
  );
}
export const ContaCard = connect(mapStateToProps, mapDispatchToProps)(ContaCardBase);

// Excluir conta e Sair: ficam em Configuracoes.
function ContaAcoesBase({ usuario, setUsuario, errors, setErrors }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dialogo, setDialogo] = useState(null); // 'deletar' | 'sair'
  const [confirmar, setConfirmar] = useState(false);
  const controller = new ControllerConfiguracoes(usuario, errors, setErrors, setLoading, setUsuario);

  function sair() {
    sessionStorage.removeItem("usuario");
    setUsuario(Usuario.model);
    navigate("/login");
  }

  return (
    <>
      {loading && <Loading />}
      {confirmar && <ConfirmarDeletarModal onClose={() => setConfirmar(false)} />}
      {dialogo === "deletar" && <DeleteDialog
        titulo={"Deseja deletar sua conta?"}
        subtitulo={"Todos os seus plantios serão excluídos e você não conseguirá recuperar sua conta."}
        onClose={() => setDialogo(null)}
        onDelete={() => controller.sendEmail(() => { setConfirmar(true); setDialogo(null); })}
      />}
      {dialogo === "sair" && <DeleteDialog
        titulo={"Sair da conta"} subtitulo={"Deseja realmente sair da conta?"}
        onClose={() => setDialogo(null)} textButton={"Sair"} onDelete={sair}
      />}
      <Acoes aria-label="Ações da conta">
        <button type="button" className="acao-sair" onClick={() => setDialogo("sair")}>Sair da minha conta</button>
        <button type="button" className="acao-deletar" onClick={() => setDialogo("deletar")}>Deletar minha conta</button>
      </Acoes>
    </>
  );
}
export const ContaAcoes = connect(mapStateToProps, mapDispatchToProps)(ContaAcoesBase);
